import { CountryPhoneDto } from "./CountryPhoneDto";

export class ClientDto {
    constructor(id, name, cellPhone, email, prospect, jobTitle, company, company_name, status, countryPhone, lastContactDate, lastContactChannel, customerStatusId, customerStatusName, leadTagName, leadTagId, enableAiAssistant, leadTags, leadTagIds, meetingDate, proposalDate, notes, value, userId, ownerName, businessName, giro, website, origin, createdAt) {
        this.id = id;
        this.name = name;
        this.cellPhone = cellPhone;
        this.email = email;
        this.prospect = prospect;
        this.jobTitle = jobTitle;
        this.company = company;
        this.company_name = company_name ?? 'Sin asignar';
        this.status = status ?? 'ACTIVE';
        this.countryPhone = countryPhone;
        this.lastContactDate = lastContactDate ?? 'Sin contacto';
        this.lastContactChannel = lastContactChannel ?? null;
        this.customerStatusId = customerStatusId ?? null;
        this.customerStatusName = customerStatusName ?? 'Sin asignar';
        this.leadTagName = leadTagName ?? 'Sin asignar';
        this.leadTagId = leadTagId ?? null;
        this.leadTags = leadTags ?? [];
        this.leadTagIds = leadTagIds ?? [];
        this.enableAiAssistant = enableAiAssistant ?? false;
        this.meetingDate = meetingDate ?? null;
        this.proposalDate = proposalDate ?? null;
        this.notes = notes ?? null;
        this.value = value ?? null;
        this.userId = userId ?? null;
        this.ownerName = ownerName ?? null;
        this.businessName = businessName ?? null;
        this.giro = giro ?? null;
        this.website = website ?? null;
        this.origin = origin ?? null;
        this.createdAt = createdAt ?? null;
    }
}